import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class TokenService {

    constructor(private http: HttpClient) {}
    
    renewToken(expiredToken: string): Observable<{message: string}> {
        return this.http.get<{message: string}>("/signup/refresh/" + expiredToken);
    }
}